module.exports = __webpack_public_path__ + "img/merida.420fccab.png";